export default {
  namespaced: true,

  state: {
    downloading: false,
    coordinateDesignated: null,
    query: {
      updatedDate: '',
      budgetLower: '',
      budgetUpper: '',
      budgetTerm: '',
      companyName: '',
      establishedYear: '',
      industryCd: [],
      companyKeyword: '',
      companyExcludeKeyword: '',
      viewEndDate: '',
      keyword: [],
      excludeKeyword: [],
      prPointCd: [],
      published: '',
      publishedRecruitMediaCd: [],
      publishedRecruitMediaTerm: '',
      publishedTerm: '',
      publishedRecruitOrAp: '',
      excludedNoCompanyTel: 'false',
      excludedNoCompanyUrl: 'false',
      applyKeywordsToCatchcopy: 'true',
      applyKeywordsToJobtypeName: 'true',
      applyKeywordsToJobContents: 'true',
      applyKeywordsToQualification: 'true',
      applyKeywordsToCompanyName: 'true',
      applyExcludeKeywordsToCatchcopy: 'true',
      applyExcludeKeywordsToJobtypeName: 'true',
      applyExcludeKeywordsToJobContents: 'true',
      applyExcludeKeywordsToQualification: 'true',
      applyExcludeKeywordsToCompanyName: 'true',
      mapNeLat: '',
      mapSwLat: '',
      mapNeLon: '',
      mapSwLon: '',
      centerLat: '',
      centerLng: '',
      distance: '',
      companyJobMark: '',
      zoom: '',
    },
  },
  getters: {
    apiQuery: state =>
      ({
        updatedDate: state.query.updatedDate,
        budgetLower: state.query.budgetLower,
        budgetUpper: state.query.budgetUpper,
        budgetTerm: state.query.budgetTerm,
        companyName: state.query.companyName,
        establishedYear: state.query.establishedYear,
        industryCd: state.query.industryCd.map(i => (i.value || i)).join(','),
        companyKeyword: state.query.companyKeyword,
        companyExcludeKeyword: state.query.companyExcludeKeyword,
        viewEndDate: state.query.viewEndDate,
        keyword: state.query.keyword.map(i => (i.value || i)).join(','),
        excludeKeyword: state.query.excludeKeyword.map(i => (i.value || i)).join(','),
        prPointCd: state.query.prPointCd.join(','),
        published: state.query.published,
        publishedRecruitMediaCd: state.query.publishedRecruitMediaCd.map(pp =>
          (pp.value || pp)).join(','),
        publishedRecruitMediaTerm: state.query.publishedRecruitMediaTerm,
        publishedTerm: state.query.publishedTerm,
        publishedRecruitOrAp: state.query.publishedRecruitOrAp,
        excludedNoCompanyTel: state.query.excludedNoCompanyTel,
        excludedNoCompanyUrl: state.query.excludedNoCompanyUrl,
        applyKeywordsToCatchcopy: state.query.applyKeywordsToCatchcopy,
        applyKeywordsToJobtypeName: state.query.applyKeywordsToJobtypeName,
        applyKeywordsToJobContents: state.query.applyKeywordsToJobContents,
        applyKeywordsToQualification: state.query.applyKeywordsToQualification,
        applyKeywordsToCompanyName: state.query.applyKeywordsToCompanyName,
        applyExcludeKeywordsToCatchcopy: state.query.applyExcludeKeywordsToCatchcopy,
        applyExcludeKeywordsToJobtypeName: state.query.applyExcludeKeywordsToJobtypeName,
        applyExcludeKeywordsToJobContents: state.query.applyExcludeKeywordsToJobContents,
        applyExcludeKeywordsToQualification: state.query.applyExcludeKeywordsToQualification,
        applyExcludeKeywordsToCompanyName: state.query.applyExcludeKeywordsToCompanyName,
        mapNeLat: state.query.mapNeLat,
        mapSwLat: state.query.mapSwLat,
        mapNeLon: state.query.mapNeLon,
        mapSwLon: state.query.mapSwLon,
        centerLat: state.query.centerLat,
        centerLng: state.query.centerLng,
        distance: state.query.distance,
        companyJobMark: state.query.companyJobMark,
        zoom: state.query.zoom,
        per_page: 300, // Map検索の取得件数固定
      }),
    coordinateDesignated: state => state.coordinateDesignated,
  },
  mutations: {
    updatedDate: (state, value) => state.query.updatedDate = value,
    budgetLower: (state, value) => state.query.budgetLower = value,
    budgetUpper: (state, value) => state.query.budgetUpper = value,
    budgetTerm: (state, value) => state.query.budgetTerm = value,
    companyName: (state, value) => state.query.companyName = value,
    establishedYear: (state, value) => state.query.establishedYear = value,
    industryCd: (state, value) => state.query.industryCd = value,
    companyKeyword: (state, value) => state.query.companyKeyword = value,
    companyExcludeKeyword: (state, value) => state.query.companyExcludeKeyword = value,
    viewEndDate: (state, value) => state.query.viewEndDate = value,
    keyword: (state, value) => state.query.keyword = value,
    excludeKeyword: (state, value) => state.query.excludeKeyword = value,
    prPointCd: (state, value) => state.query.prPointCd = value,
    published: (state, value) => state.query.published = value,
    publishedRecruitMediaCd: (state, value) => state.query.publishedRecruitMediaCd = value,
    publishedRecruitMediaTerm: (state, value) => state.query.publishedRecruitMediaTerm = value,
    publishedTerm: (state, value) => state.query.publishedTerm = value,
    publishedRecruitOrAp: (state, value) => state.query.publishedRecruitOrAp = value,
    excludedNoCompanyTel: (state, value) => state.query.excludedNoCompanyTel = value,
    excludedNoCompanyUrl: (state, value) => state.query.excludedNoCompanyUrl = value,
    applyKeywordsToCatchcopy: (state, value) => state.query.applyKeywordsToCatchcopy = value,
    applyKeywordsToJobtypeName: (state, value) => state.query.applyKeywordsToJobtypeName = value,
    applyKeywordsToJobContents: (state, value) => state.query.applyKeywordsToJobContents = value,
    applyKeywordsToQualification: (state, value) => state.query.applyKeywordsToQualification = value,
    applyKeywordsToCompanyName: (state, value) => state.query.applyKeywordsToCompanyName = value,
    applyExcludeKeywordsToCatchcopy: (state, value) => state.query.applyExcludeKeywordsToCatchcopy = value,
    applyExcludeKeywordsToJobtypeName: (state, value) => state.query.applyExcludeKeywordsToJobtypeName = value,
    applyExcludeKeywordsToJobContents: (state, value) => state.query.applyExcludeKeywordsToJobContents = value,
    applyExcludeKeywordsToQualification: (state, value) => state.query.applyExcludeKeywordsToQualification = value,
    applyExcludeKeywordsToCompanyName: (state, value) => state.query.applyExcludeKeywordsToCompanyName = value,
    mapNeLat: (state, value) => state.query.mapNeLat = value,
    mapSwLat: (state, value) => state.query.mapSwLat = value,
    mapNeLon: (state, value) => state.query.mapNeLon = value,
    mapSwLon: (state, value) => state.query.mapSwLon = value,
    centerLat: (state, value) => state.query.centerLat = value,
    centerLng: (state, value) => state.query.centerLng = value,
    distance: (state, value) => state.query.distance = value,
    companyJobMark: (state, value) => state.query.companyJobMark = value,
    zoom: (state, value) => state.query.zoom = value,
    coordinateDesignated: (state, value) => state.coordinateDesignated = value,
    addKeyword: (state, value) => {
      state.query.keyword.push(value)
    },
    addExcludeKeyword: (state, value) => {
      state.query.excludeKeyword.push(value)
    },
    removeKeyword: (state, index) => {
      state.query.keyword.splice(index, 1)
    },
    removeExcludeKeyword: (state, index) => {
      state.query.excludeKeyword.splice(index, 1)
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/searchMap.js